const KeenSlider = window.KeenSlider

const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class ProductCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.disableOnMobile = this.dataset.disableOnMobile === 'true'

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        disabled: this.disableOnMobile,
        slides: {
          perView: 1,
          spacing: 0,
        },
        breakpoints: {
          '(min-width: 768px)': {
            disabled: this.disableOnMobile,
            slides: {
              perView: 2,
              spacing: 0,
            },
          },
          '(min-width: 901px)': {
            disabled: false,
            slides: {
              perView: 2,
              spacing: 0,
            },
          },
          '(min-width: 1201px)': {
            disabled: false,
            slides: {
              perView: 3,
              spacing: 0,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('product-carousel')) {
  customElements.define('product-carousel', ProductCarousel)
}
